import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import './IndexesFromLegalMatters.scss';

const IndexesFromLegalMatters = () => {

    const [ content, setContent ] = useState([])
    const breakpoint = useMediaQuery('(max-width: 844px)')

    useEffect(() => {
        const allClasses = document.getElementsByClassName("quillIndexLegalMatter")
        if (allClasses && allClasses.length) {
            let i
            let indexData = []
            for (i = 0; i < allClasses.length; i++) {
                indexData.push({
                    id: allClasses[i].id,
                    text: allClasses[i].innerHTML,
                    class: allClasses[i].classList
                })
            }
            setContent(indexData)
        }
    }, [])

    return (
        <div className='IndexesFromLegalMatters'>
            <p className='IndexesFromLegalMatters_title'>Contenidos</p>
            <div className='IndexesFromLegalMatters_container'>
                {content && content.length !== 0 && content.map((elem, index) => {
                    return (
                        <h5 className='IndexesFromLegalMatters_buttonContainer'>
                            <Link
                                key={index}
                                to={elem.id}
                                className='IndexesFromLegalMatters_button'
                                offset={breakpoint? -60 : -85}
                            >
                                {elem.text}
                            </Link>
                        </h5>
                    )
                })}
            </div> 
        </div>
    )
}

export default IndexesFromLegalMatters;
